<template>
    <div class="clearfix">
        <form action="" style="padding: 0; maring: 0" ref="searchForm">
            <div :class="prefixCls + '-wrapper'" :style="wrapStyle">
                <!-- 指定字段搜索 -->
                <Dropdown
                    v-if="columns"
                    :class="prefixCls + '-drop'"
                    :style="dropStyle"
                    trigger="click"
                    transfer
                    @on-click="onColClick"
                >
                    <div class="single-line" :class="prefixCls + '-drop-el'">
                        <span>{{ targetTitle }}</span>
                        <common-icon
                            :class="prefixCls + '-drop-arrow'"
                            type="ios-arrow-down"
                        ></common-icon>
                    </div>
                    <DropdownMenu slot="list">
                        <DropdownItem
                            v-for="(col, i) in columns"
                            :key="i"
                            :name="col.key"
                            :selected="col.key === targetKey"
                            >{{ col.title }}</DropdownItem
                        >
                    </DropdownMenu>
                </Dropdown>
                <!-- 泛字段搜索 -->
                <common-icon
                    v-else
                    type="ios-search"
                    :class="prefixCls + '-icon'"
                    style="left: 8px"
                ></common-icon>
                <Input
                    :class="prefixCls + '-input-wraper'"
                    :value="inputVal"
                    :placeholder="finalPlaceHolder"
                    :clearable="true"
                    :inputStyle="inputStyle"
                    @input="onInput"
                ></Input>
                <Button
                    type="primary"
                    :class="prefixCls + '-btn'"
                    @click="search"
                    >搜索</Button
                >
            </div>
        </form>
    </div>
</template>
<script>
import CommonIcon from '../common-icon'
import Input from '../input'
import Button from '../button'
import Dropdown from '../dropdown'
import DropdownMenu from '../dropdown-menu'
import DropdownItem from '../dropdown-item'

export default {
    name: 'TableSearcher',

    components: {
        CommonIcon,
        Button,
        Input,
        Dropdown,
        DropdownMenu,
        DropdownItem,
    },

    model: {
        prop: 'searchValue',
        event: 'input',
    },

    props: {
        // 搜索值
        // 对象模式格式为 { key: '字段名', alias: '别名', val: '搜索值', op: '操作符' }
        searchValue: {
            type: [String, Object],
            default: '',
        },
        // 提示语
        placeholder: {
            type: String,
            default: '',
        },
        // 总宽度
        width: {
            type: Number,
            default: 292,
        },
        // 左侧区域宽度（配合columns使用）
        leftWidth: {
            type: Number,
            default: 100,
        },
        // 是否去掉首尾空格
        trim: {
            type: Boolean,
            default: true,
        },
        // 如果传递columns，则默认开启对象模式
        columns: {
            type: Array,
            default: null,
        },
    },

    data() {
        return {
            inputVal: '',
            targetKey: '',
        }
    },

    computed: {
        prefixCls() {
            return 'ivu-table-searcher'
        },
        wrapStyle() {
            return {
                width: this.width + 'px',
            }
        },
        dropStyle() {
            return {
                width: this.leftWidth + 'px',
            }
        },
        inputStyle() {
            return {
                'border-right': '0',
                'border-radius': '4px',
                'padding': '0 57px 0 64px',
                'padding-left': (this.columns ? this.leftWidth : 32) + 'px',
            }
        },
        finalPlaceHolder() {
            if (this.columns) {
                return `请输入${this.targetTitle}`
            } else {
                return this.placeholder
            }
        },
        targetTitle() {
            var target = this.columns.find(
                v => v.key && v.key === this.targetKey
            )

            return target ? target.title : ''
        },
        alias() {
            var target = this.columns.find(
                v => v.key && v.key === this.targetKey
            )

            return target && target.schema ? target.schema.alias : ''
        },
    },

    watch: {
        searchValue: {
            handler(v) {
                if (this.columns) {
                    v = v || { val: [] }

                    this.inputVal = v.val && v.val[0] || ''
                    this.targetKey = v.key || ''
                } else {
                    this.inputVal = v
                }
            },
            immediate: true,
        },
        columns: {
            handler(v) {
                // 默认选中第一个
                if(!this.targetKey && v && v.length){
                    this.targetKey = v[0].key
                }
            },
            immediate: true,
        },
    },

    methods: {
        search(e) {
            e.preventDefault()
            this.$emit('search')
        },
        // 文本输入
        onInput(value) {
            // 对象模式
            if (this.columns) {
                this.$emit('input', {
                    key: this.targetKey,
                    alias: this.alias,
                    val: [value],
                    op: 'like',
                })
            } else {
                this.$emit('input', this.trim ? value.trim() : value)
            }

            // 清空
            if (value == '') {
                this.$emit('clear')
            }
        },
        // 字段选择
        onColClick(name) {
            this.targetKey = name
            this.onInput(this.inputVal)
        },
    },
    mounted() {
        this.$refs.searchForm.onsubmit = this.search
    },
}
</script>